import React from "react";

export const HeaderNav: React.FC = () => {
  return <h2>Balie Checkout</h2>;
};

export default HeaderNav;
